import { Box, Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid2';

/**
 * Loading skeleton grid for Balena device cards.
 * Mirrors BalenaDeviceCard layout and BalenaDevicesGrid breakpoints.
 */
export function BalenaDevicesGridSkeleton({ count = 2 }: { count?: number }) {
  return (
    <Grid container spacing={2.5}>
      {Array.from({ length: count }).map((_, index) => (
        <Grid size={{ xs: 12, sm: 6, lg: 6, xl: 4 }} key={index}>
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              border: 1,
              borderColor: 'divider',
              borderRadius: 2,
              overflow: 'hidden',
            }}
          >
            <Skeleton variant="rectangular" height={118} sx={{ flexShrink: 0 }} />
            <Box sx={{ flexGrow: 1, pt: 1.5, pb: 0, px: 2 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 1,
                  mb: 0.75,
                }}
              >
                <Skeleton width="55%" height={28} />
                <Skeleton variant="rounded" width={64} height={22} />
              </Box>
              <Skeleton width="70%" height={16} sx={{ mb: 1.5 }} />
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1,
                px: 2,
                pb: 1.5,
                pt: 1,
                borderTop: 1,
                borderColor: 'divider',
              }}
            >
              <Skeleton width={72} height={20} />
              <Skeleton width={96} height={16} />
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}
